import Button from 'react-bootstrap/Button';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

export const StyledModalBody = styled(Modal.Body)`
  padding: 64px 23px 0 23px ;
  position: relative;
`;

export const StyledParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 154%;
  text-align: center;
  color: #4F5388;
  margin-bottom: 43px;
  padding: 0 20px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledSpan = styled.span`
  font-family: NunitoSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 156%;
  text-align: center;
  letter-spacing: 0.01em;
  color: #1C62EF;
  margin-left: 15px;
  width: 198px;
`;

export const StyledModalFooter = styled(Modal.Footer)`
  border-top-width: 0 ;
  justify-content: center ;
`;

export const StyledModalBtn = styled(Button)`
  &.DeleteStyle{
    margin: 30px 0 !important;
    width: 162px;
    height: 50px;
    border-radius: 8px !important;
    color: #EF1C62;
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 115%;
    text-align: center;
    &:hover{
      box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
      background: transparent;
      color: #EF1C62;
    }
    &:focus{
      box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
      background: transparent;
      color: #EF1C62;
    }
    &:not(:disabled):not(.disabled):active{
      box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
      background-color: transparent;
      color: #EF1C62;
    }
  }
  &.HeaderBtn{
    position: absolute;
    top: -14px;
    right: -12px;
    padding: 10px;
    background: #fff;
    border-radius: 100%;
    border-width: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
    &:hover{
      box-shadow: none;
      border-radius: 100%;
      border-width: 0;
    }
    &:focus{
      border-width: 0;
      box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
      border-radius: 100%;
    }
  }
`;

export const StyledImg = styled.img`
  width: 100%;
`;